<script type="text/javascript">

	import moment from "moment";
	import Chart from "chart.js";
	import { onDestroy, onMount } from "svelte";

	export let title = "";
	export let data = null;
	export let key = null;
	export let avg = "";
	export let xAxisDecimalPlaces = 0;
	export let xAxisUnit = "Hours";

	let snapshot = data[0];
	let avgValue = 0.0;

	let chart = null;
	let canvas = null;
	
	let valid = true;

	onMount(() => {
	   updateChart();
	})
	onDestroy(()=>{
		if (chart !== null) {
			chart.destroy();
			chart = null;
		}
	});
	$: {
		updateChart();
	}
	
	let updateChart = () => {
		// console.log("update chart", chart, canvas, data);
		if (chart === null && canvas !== null && data !== null) {
			// Get newest date
			data.sort((a, b) => {
				return moment(b.Date) - moment(a.Date);
			});
			let latest = data[0].data;
			let histogramData = latest.Graph_type[key];

			avgValue = latest.Graph_type[avg];

			let edges = histogramData.edges.map((item, i)=>{ 
				// console.log(i, item);
				return (item).toFixed(xAxisDecimalPlaces); 
			});
			let values = histogramData.values;
			// console.log("edges", edges, "values", values);

			const chartData = {
				labels: edges, 
				datasets: [
					{
						label: "test",
						data: values, 
						backgroundColor: "rgba(255, 99, 132, 1)",
						xAxisID: "x",
						yAxisID: "y"
					}
				]
			};
			if (histogramData.edges.length < 2 || 
				(histogramData.edges.length == 2 && values[0] === 0)) {
				valid = false;
				return;
			}
			let xStepSize = histogramData.edges[1] - histogramData.edges[0];
			// 
			const config = {
				type: 'bar',
				data: chartData,
				options: {
					responsive: true,
					//plugins: {
						legend: {
							display: false,
							title: {
								display: false
							}
						},
					//},
					tooltips: {
						enabled: true,
						callbacks: {
							title: (item, data) => {
								// console.log("item", item, "data", data);
								// item[0].label
								let thisIndex = item[0].index;
								let nextIndex = item[0].index + 1;
								return data.labels[thisIndex] + " - " + data.labels[nextIndex] + " " + xAxisUnit;
							},
							label: (item, data) => {
								// let useIndex = item.datasetIndex;
								// let useValue = ;
								// return useValue + " ...";
								return "" + item.value;
							}
							// ,
							// footer: () => {
							// 	return "";
							// }
						}
					},
					scales: {
						xAxes: [{
							id: "x",
							display: true,
							scaleLabel: {
								display: true
							},
							ticks: {
								stepSize: xStepSize
							}
							//,
							// title: {
							// 	display: true,
							// 	text: "Hours"
							// }
						}],
						// y: {
						// 	display: true,
						// 	title: {
						// 		display: true,
						// 		text: "Frequency"
						// 	},
						// 	scaleLabel: {
						// 		labelString: "Frequency_abc"
						// 	}
						// },
						yAxes: [{
							id: "y",
							scaleLabel: {
								display: true
							},
							ticks: {
								beginAtZero: true
							}
						}]
					} //,
					// layout: {
					//     padding: 0
					// },
					// elements: {
					//     bar: {
					//         padding: 0
					//     }
					// }
				},
			};
			chart = new Chart(canvas.getContext("2d"), config);
			chart.options.scales.xAxes[0].scaleLabel.labelString = xAxisUnit;
			chart.options.scales.yAxes[0].scaleLabel.labelString = "Frequency";
			//chart.options.legend.display = false;
			//chart.options.legend.title.display = false;
		}
		if (chart !== null && canvas !== null) {
 			if (valid) {
				chart.update();
			}
		}
	}

</script>

<p><b>{title}</b></p>
{#if !valid}
	<p><i>Not enough data to populate graph.</i></p>
{:else}
	{#if data.length > 0}
		<canvas bind:this={canvas}></canvas>
		{#if avg.length > 0}
			<p><i>Mean Average: {(avgValue).toFixed()} {xAxisUnit}</i></p>
		{/if}
	{:else}
		<p>No Data</p>
	{/if}
{/if}
